// Was in einem Brief noch auszufüllen ist: jeder {{…}}-Platzhalter (auch {{eingabe.x|Beschriftung|typ}}) und
// „[bitte … eintragen]“. „Per Post senden“ verschickt nichts, solange etwas davon übrig ist.
const OFFEN = /\{\{[^}]+\}\}|\[bitte[^\]]*\]/gi;

export function offenePlatzhalter(...texte: string[]): string[] {
  return [...new Set(texte.flatMap((t) => t.match(OFFEN) ?? []))];
}
